import { render, staticRenderFns } from "./LineClassListDetail.vue?vue&type=template&id=ffa993fc&scoped=true"
import script from "./LineClassListDetail.vue?vue&type=script&lang=js"
export * from "./LineClassListDetail.vue?vue&type=script&lang=js"
import style0 from "./LineClassListDetail.vue?vue&type=style&index=0&id=ffa993fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa993fc",
  null
  
)

export default component.exports